<template>
  <div style="min-height: calc(100vh - 185px)">
    <!--    <pre v-if="ads_config">{{ ads_config.ads_config.live_stream_ads }}</pre>-->

    <div style="margin-top: 40px; display: flex; gap: 30px; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>
      <strong style="font-size: 18px"> {{ 'Tạo quảng cáo Livestream' }} </strong>
    </div>

    <!--    <pre>{{ ads_data ? ads_data.has_ads : null }}</pre>-->

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.basic_settings') }}</strong>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.campaign_name') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-input type="text" v-model="campaign_info.name" size="mini" style="width: 420px" maxlength="50"
                    show-word-limit></el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.budget') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio style="width: 150px" v-model="campaign_info.budget_type" label="unlimited">
            {{ $t('base.unlimited') }}
          </el-radio>
          <el-radio v-model="campaign_info.budget_type" label="daily_budget">{{ $t('base.daily_budget') }}</el-radio>
          <el-input v-if="campaign_info.budget_type === 'daily_budget'" v-model="campaign_info.daily_budget"
                    type="number" size="mini" placeholder="Nhập ngân sách ngày"></el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.date') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio style="width: 150px" v-model="campaign_info.campaign_date" label="unlimited">
            {{ $t('base.unlimited') }}
          </el-radio>
          <el-radio v-model="campaign_info.campaign_date" label="daterange">{{
              $t('base.set_start_end_date')
            }}
          </el-radio>
          <el-date-picker
            v-if="campaign_info.campaign_date === 'daterange'"
            v-model="campaign_info.campaign_date_range"
            type="daterange" range-separator="-"
            size="mini"
            format="dd-MM-yyyy"
            :start-placeholder="$t('base.start_date')" :end-placeholder="$t('base.end_date')"
            :clearable="false">
          </el-date-picker>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.time') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio style="width: 150px" v-model="campaign_info.campaign_time" label="unlimited">
            {{ $t('base.all_day') }}
          </el-radio>
          <el-radio v-model="campaign_info.campaign_time" label="timerange"
                    :disabled="campaign_info.objective !== 'max_view'">{{
              $t('base.set_start_end_hour')
            }}
          </el-radio>
          <el-time-picker
            v-if="campaign_info.campaign_time === 'timerange'"
            v-model="campaign_info.campaign_time_range"
            is-range
            arrow-control
            format="HH:mm"
            size="mini"
            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
            :clearable="false"
          >
          </el-time-picker>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ 'Chiến lược Đấu thầu' }}</strong>

      <div style="margin-top: 30px; display: flex; gap: 20px">
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer"
          :style="campaign_info.objective === 'max_gmv' ? 'border: 1px solid #ee4d2d' : ''"
          @click="campaign_info.objective = 'max_gmv'; campaign_info.campaign_time = 'unlimited'">
          <div style="flex: 1;display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ 'Tối ưu doanh thu' }}</div>
            <div style="color: #999; font-size: 13px">
              {{ ' Tăng doanh số cho Livestream nhờ hiển thị tới người mua tiềm năng ' }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-livestream/image/max-gmv.b1cec78.png"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>

        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer"
          :style="campaign_info.objective === 'max_view' ? 'border: 1px solid #ee4d2d' : ''"
          @click="campaign_info.objective = 'max_view'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ 'Tối ưu Lượt xem' }}</div>
            <div style="color: #999; font-size: 13px">
              {{ ' Hiển thị Livestream tới người xem tiềm năng ' }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-livestream/image/max-views.0ee452a.png"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>
      </div>

      <div v-if="campaign_info.objective === 'max_gmv'"
           style="margin-top: 30px; background: #fafafa; border-radius: 8px; padding: 20px">
        <div style="font-size: 13px; color: #666">
          Mục tiêu ROAS
        </div>
        <div style="display: flex; flex-direction: column; gap: 30px; margin-top: 30px">
          <div>
            <el-radio v-model="campaign_info.target_broad_roi_type" label="auto">Tự động</el-radio>
            <br>
            <span style="font-size: 12px; color: #999">
              Tối đa hóa doanh thu mà vẫn duy trì ROAS trong phạm vi ước tính sau 7 ngày máy học.
            </span>
          </div>
          <div>
            <el-radio v-model="campaign_info.target_broad_roi_type" label="manual">Tuỳ chỉnh</el-radio>
            <br>
            <span style="font-size: 12px; color: #999">
              Phát huy toàn bộ tiềm năng tối đa GMV khi Livestream trên Shopee bằng cách tận dụng lưu lượng truy cập
              quảng cáo và truy cập tự nhiên chất lượng.
            </span>

            <div v-if="campaign_info.target_broad_roi_type === 'manual'"
                 style="margin-top: 10px; background: #fff; padding: 16px 24px; width: 600px; display: flex; flex-direction: column; gap: 15px">
              <div v-for="roas in roas_list" :key="roas.value" class="flex gap-[30px] items-center">
                <el-radio v-model="campaign_info.target_broad_roi_value"
                          :label="roas.value.toString()">ROAS = {{ roas.value }}
                </el-radio>

                <div>
                  <span>
                    Cạnh tranh hiển thị tốt hơn
                  </span>
                  <span style="color: orangered">{{ roas.percent }}%</span>
                  <span>chiến dịch tương tự</span>
                </div>
              </div>

              <div class="flex gap-[30px] items-center mt-[5px]">
                <el-radio v-model="campaign_info.target_broad_roi_value" :label="'custom'">Tuỳ chọn một giá trị
                </el-radio>
                <el-input v-model="campaign_info.target_broad_roi" size="mini" style="width: 200px"
                          :disabled="campaign_info.target_broad_roi_value !== 'custom'"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin: 50px 0" class="text-right">
        <el-button type="primary" size="medium" :loading="loading.create_campaign" icon="el-icon-check"
                   @click="m__confirm_create_new_live_stream_campaign">{{ $t('base.create_new_campaign') }}
        </el-button>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.overlapping_ads_for_roi_two" :close-on-click-modal="false"
               width="650px">
      <div slot="title" style="padding: 10px">
        <strong style="font-size: 18px">
          Bạn có một quảng cáo Livestream Tối Đa Doanh Thu Tùy Chỉnh ROAS đang diễn ra/lên lịch
        </strong>

        <div style="margin-top: 20px; font-size: 13px">
          Thiết lập Quảng cáo này sẽ dừng quảng cáo Tối Đa Doanh Thu Tùy Chỉnh ROAS. Chúng tôi khuyên bạn nên duy trì
          hoạt động của quảng cáo để đạt hiệu quả tốt nhất.
        </div>

        <div style="margin-top: 20px; text-align: right">
          <el-button size="mini" @click="show_dialog.overlapping_ads_for_roi_two = false">Hủy</el-button>
          <el-button type="primary" size="mini" @click="m__confirm_create_new_live_stream_campaign(false)">Tiếp tục
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {fix_ads_mixins} from '../../../mixins/fix_ads'
import {package_mixins} from '../../../mixins/package'
import {make_uuid} from "../../../addon/ads_function";

export default {
  mixins: [fix_ads_mixins, package_mixins],

  props: {
    shop: null,
    sp_user: null,
    ads_config: null,
    ads_data: null,
    non_ads_data: null,
  },

  data() {
    return {
      campaign_info: {
        name: '',
        budget_type: 'unlimited',
        daily_budget: null,
        campaign_date: 'unlimited',
        campaign_date_range: [new Date(), this.dayjs().add(2, 'weeks').endOf('day').toDate()],
        campaign_time: 'unlimited',
        campaign_time_range: [this.dayjs().startOf('day').toDate(), this.dayjs().endOf('day').toDate()],
        objective: 'max_gmv',
        target_broad_roi_type: 'auto',
        target_broad_roi_value: null,
        target_broad_roi: null,
      },
      roas_list: [],
      loading: {
        create_campaign: false,
      },
      show_dialog: {
        overlapping_ads_for_roi_two: false
      },
      max_view_min_daily_budget: null,
      max_gmv_min_daily_budget: null
    }
  },

  async mounted() {
    this.campaign_info.name = `Quảng cáo cho Livestream ${this.dayjs().format('YYYY-MM-DD HH:mm')} ${this.dayjs().unix()}`.slice(0, 50)

    if (this.sp_user) {
      const get_recommended_roi_two_target_response = await this.sp_user.marketing_pas_get_recommended_roi_two_target(null, make_uuid(), 'live_stream')
      if (get_recommended_roi_two_target_response && get_recommended_roi_two_target_response.data) {
        this.roas_list.push({
          percent: get_recommended_roi_two_target_response.data.lower_bound.percentile,
          value: get_recommended_roi_two_target_response.data.lower_bound.value / 100000
        })
        this.roas_list.push({
          percent: get_recommended_roi_two_target_response.data.exact.percentile,
          value: get_recommended_roi_two_target_response.data.exact.value / 100000
        })
        this.roas_list.push({
          percent: get_recommended_roi_two_target_response.data.upper_bound.percentile,
          value: get_recommended_roi_two_target_response.data.upper_bound.value / 100000
        })
      }
    }

    if (this.ads_config) {
      this.max_view_min_daily_budget = this.ads_config.ads_config.live_stream_ads.min_daily_budget / 100000
      this.max_gmv_min_daily_budget = this.ads_config.ads_config.live_stream_ads.target_broad_roi.min_daily_budget / 100000
      // console.log(this.max_view_min_daily_budget)
      // console.log(this.max_gmv_min_daily_budget)
    }
  },

  computed: {
    c__has_live_stream__max_gmv_roi_two() {
      return this.ads_data && this.ads_data.has_ads && this.ads_data.has_ads.live_stream__max_gmv_roi_two
    }
  },

  methods: {
    m__back_to_list() {
      this.$emit('back_to_list')
    },

    async m__confirm_create_new_live_stream_campaign(ask_for_overlapping = true) {
      if (!this.campaign_info.name.trim()) {
        this.ntf_w('Vui lòng nhập tên quảng cáo')
        return
      }

      if (this.campaign_info.budget_type === 'daily_budget') {
        if (+this.campaign_info.daily_budget) {
          if (this.campaign_info.objective === 'max_view' && +this.campaign_info.daily_budget < this.max_view_min_daily_budget) {
            this.ntf_w(`Ngân sách tối thiểu phải lớn hơn ${this.max_view_min_daily_budget}`)
            return
          }

          if (this.campaign_info.objective === 'max_gmv' && +this.campaign_info.daily_budget < this.max_gmv_min_daily_budget) {
            this.ntf_w(`Ngân sách tối thiểu phải lớn hơn ${this.max_gmv_min_daily_budget}`)
            return
          }
        } else {
          this.ntf_w('Vui lòng nhập ngân sách ngày')
          return
        }
      }

      if (this.campaign_info.campaign_date === 'daterange' && !this.campaign_info.campaign_date_range.length) {
        this.ntf_w('Vui lòng chọn ngày chạy quảng cáo')
        return
      }

      if (this.campaign_info.target_broad_roi_type === 'manual') {
        if (!this.campaign_info.target_broad_roi_value) {
          this.ntf_w('Vui lòng chọn mục tiêu ROAS')
          return
        }

        if (this.campaign_info.target_broad_roi_value === 'custom' && !+this.campaign_info.target_broad_roi) {
          this.ntf_w('Vui lòng nhập giá trị ROAS')
          return
        }
      }

      this.loading.create_campaign = true

      if (ask_for_overlapping) {
        if (this.campaign_info.objective !== 'max_view') {
          const start_time = this.dayjs().startOf('day').unix()
          const end_time = 0
          const objective = this.c__has_live_stream__max_gmv_roi_two ? 'max_gmv_roi_two' : 'max_gmv'
          const check_overlapping_response = await this.sp_user.marketing_pas_check_live_stream_overlapping_ads_for_roi_two(start_time, end_time, objective)
          if (check_overlapping_response && check_overlapping_response.data && check_overlapping_response.data.has_overlap) {
            this.show_dialog.overlapping_ads_for_roi_two = true
            this.loading.create_campaign = false
            return
          }
        }
      } else {
        this.show_dialog.overlapping_ads_for_roi_two = false
      }

      const campaign = {
        daily_budget: this.campaign_info.budget_type === 'unlimited' ? 0 : Math.trunc(this.campaign_info.daily_budget * 100000),
        start_time: this.campaign_info.campaign_date === 'unlimited' ? this.dayjs().startOf('day').unix() : this.dayjs(this.campaign_info.campaign_date_range[0]).unix(),
        end_time: this.campaign_info.campaign_date === 'unlimited' ? 0 : this.dayjs(this.campaign_info.campaign_date_range[1]).unix(),
        time_slot_list: [
          {
            start_time: 0,
            end_time: 0
          }
        ],
        name: this.campaign_info.name,
        objective: this.campaign_info.objective,
      }

      if (this.campaign_info.target_broad_roi_type === 'auto') {
        if (this.c__has_live_stream__max_gmv_roi_two) {
          campaign.roi_two_target = 0
        } else {
          campaign.target_broad_roi = 0
        }
      }

      if (this.campaign_info.target_broad_roi_type === 'manual') {
        if (this.campaign_info.target_broad_roi_value === 'custom') {
          if (this.c__has_live_stream__max_gmv_roi_two) {
            campaign.roi_two_target = Math.trunc(+this.campaign_info.target_broad_roi * 100000)
          } else {
            campaign.target_broad_roi = Math.trunc(+this.campaign_info.target_broad_roi * 100000)
          }
        } else {
          if (this.c__has_live_stream__max_gmv_roi_two) {
            campaign.roi_two_target = Math.trunc(+this.campaign_info.target_broad_roi_value * 100000)
          } else {
            campaign.target_broad_roi = Math.trunc(+this.campaign_info.target_broad_roi_value * 100000)
          }
        }
      }

      if (this.campaign_info.objective === 'max_view') {
        if (this.campaign_info.campaign_time === 'timerange') {
          const start_of_day = this.dayjs().startOf('day')
          const start_time = this.dayjs(new Date(this.campaign_info.campaign_time_range[0]))
          const end_time = this.dayjs(new Date(this.campaign_info.campaign_time_range[1]))

          const diff_start_time = start_time.diff(start_of_day, 'minute')
          const diff_end_time = end_time.diff(start_of_day, 'minute')

          campaign.time_slot_list[0].start_time = diff_start_time * 60
          campaign.time_slot_list[0].end_time = diff_end_time * 60
        }

        delete campaign.roi_two_target
        delete campaign.target_broad_roi
      }

      if (this.c__has_live_stream__max_gmv_roi_two && campaign.objective === 'max_gmv') {
        campaign.objective = 'max_gmv_roi_two'
      }

      const form = {
        campaign: campaign,
        reference_id: make_uuid(),
        header: {}
      }

      const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'live_stream')
      console.log(create_response)

      if (create_response) {
        if (create_response.code === 0) {
          this.ntf_s('Tạo quảng cáo thành công')
        } else {
          this.ntf_w(`Đã có lỗi trong quá trình tạo quảng cáo. Mã lỗi: ${create_response.msg} - ${JSON.stringify(create_response.validation_error_list ? create_response.validation_error_list : '')}`)
        }
      } else {
        this.ntf_w(this.$t('base.has_an_occurred'))
      }

      this.loading.create_campaign = false
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/create_live_stream.vue